import { IElement } from "core-integration/src/store/elements/types";
import React from "react";
import styled, { css } from "styled-components";

const ElementName = styled.div<IStyledProps>`
  padding: 0.3rem 0.3rem;
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.black};
  font-size: 1rem;
  font-weight: 400;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  direction: ltr;

  ${(props) =>
    props.element.news &&
    props.element.chance_of_playing_next_round !== null &&
    css`
      background-color: ${
        props.theme.colors.elementStatus[
          props.element.chance_of_playing_next_round
        ].bg
      };
      color: ${
        props.theme.colors.elementStatus[
          props.element.chance_of_playing_next_round
        ].color
      };
    `}

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    padding-top: 0.3rem;
    padding-bottom: 0.3rem;
    font-size: ${({ theme }) => theme.fontSizes[0]};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints[4]}) {
    padding-top: 0.4em;
    padding-bottom: 0.4em;
    font-size: ${({ theme }) => theme.fontSizes[1]};
  }
`;

export const ElementValue = styled.div`
  padding: 0.2rem 0.2rem;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  font-size: 0.9rem;
  font-weight: 800;

  @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
    padding-top: 0.3rem;
    padding-bottom: 0.3rem;
    font-size: ${({ theme }) => theme.fontSizes[0]};
  }
`;

interface IStyledProps {
  element: IElement;
}

interface IProps {
  value: React.ReactNode;
}

type Props = IStyledProps & IProps;

const PitchElementData: React.FC<Props> = ({ element, value }) => (
  <div>
    <ElementName element={element}>{element.web_name}</ElementName>
    <ElementValue>{value}</ElementValue>
  </div>
);

export default PitchElementData;
